export enum tablePaginationPositions {
  BOTTOM_CENTER = 'bottomCenter',
}
